
export const FILE_STATES: any[] = [
    {
        id: 'ACTIVE',
        name: 'Активен',
    },
    {
        id: 'EXPIRED',
        name: 'Истек'
    },
    {
        id: 'BLOCKED',
        name: 'Заблокирован'
    },
];